import clsx from 'clsx';

const GlobalLoading = ({ show, middleAlignment, endAlignment, customClass, innerWrapClass }) => (
  <div className={clsx('absolute inset-0 flex justify-center z-40',
    customClass,
    !show && 'hidden',
    endAlignment && 'items-end', !middleAlignment && !endAlignment && 'items-start', middleAlignment && !endAlignment && 'items-center',
  )}>
    <div className={innerWrapClass}>
      <div className="loader-360 w-56 h-56" />
      <span className="absolute inset-0 flex items-center justify-center text-5xl font-bold text-loading" />
    </div>
  </div>
);

export default GlobalLoading;